export default "__VITE_ASSET__BjStk3sr__"